import { VisitorChatbotConfig } from '../interfaces/visitor-chatbot.interface';

export const VISITOR_CHATBOT_CONFIG: VisitorChatbotConfig = {
  title: 'VISITOR_CHATBOT.TITLE',
  welcomeMessage: 'VISITOR_CHATBOT.WELCOME_MESSAGE',
  placeholder: 'VISITOR_CHATBOT.PLACEHOLDER',
  services: [], // Removed services as per requirement
  features: {
    textToSpeech: true,
    copyMessages: true,
    fullscreen: true,
    minimizable: true,
    showCompanyInfo: true,
    showContactInfo: true,
    voiceSettings: true,
    delayedIntro: true
  },
  theme: {
    primaryColor: '#300458',    // Deep purple from index page
    headerColor: '#6a1b9a',     // Primary purple from variables
    buttonColor: '#e44891',     // Accent pink from index page
    backgroundColor: '#ffffff'
  },
  position: 'bottom-right',
  size: 'large',
  contactInfo: {
    phone: '+966 57 609 3104',
    email: 'support@5dma.vip',
    website: 'https://5dma.vip',
    workingHours: 'VISITOR_CHATBOT.WORKING_HOURS'
  },
  companyInfo: {
    name: '5dma',
    description: 'VISITOR_CHATBOT.COMPANY_DESCRIPTION',
    logo: 'assets/images/logo.png'
  }
};
